export enum HMSVideoCodec {
  VP8 = 'vp8',
  VP9 = 'vp9',
  H264 = 'h264',
}

export enum HMSAudioCodec {
  OPUS = 'opus',
}
